export const shareByEmail = (subject: string, body: string) => {
  document.location = `mailto:?subject=${subject}&body=${encodeURIComponent(body)}`;
};
